import z from "zod";

const propertiesSchema = z.object({
	label: z.string(),
	geometry_id: z.string(),
	poi_type: z.string(),
	title: z.string(),
	test_key: z.string().optional(),
});

const coordinatesSchema = z.union([
	z.array(z.array(z.array(z.number()))),
	z.array(z.array(z.array(z.array(z.number())))),
]);

const geometrySchema = z.object({
	type: z.string(),
	coordinates: coordinatesSchema,
});

const featureSchema = z.object({
	type: z.string(),
	properties: propertiesSchema,
	geometry: geometrySchema,
});

export const areaSchema = z.object({
	type: z.string(),
	features: z.array(featureSchema),
});
